import React from 'react';
import { NEWS_ARTICLES } from '../../lib/queries';
import client from '../../lib/apolloClient';
import Layout from '../../src/components/Layout/Layout';
import NewsComponent from '../../src/components/News/News';
import replacePictureUrlWithSignedUrl from '../../src/utils/replaceUrlWithSigned/replaceUrlWithSigned';

const News = (props) => {
  const { data } = props;
  return (
    <Layout>
      <NewsComponent data={data} />
    </Layout>
  );
};

export default News;

export async function getServerSideProps() {
  let { data } = await client.query({ query: NEWS_ARTICLES });
  data = await replacePictureUrlWithSignedUrl(data);
  return {
    props: { data },
  };
}
